<template>
    <router-link
        v-if="type === 'link'"
        :class="params.class"
        :exact-active-class="params?.activeClass"
        :to="{path: params.path}"
    >
        {{ label ?? params.title }}
        <slot />
    </router-link>

    <!-- DEPRECATED Don`t use "<brn-wrapper params={ type: 'link-a'}", use "<brn-wrapper type='a'" instead -->
    <a
        v-else-if="type === 'link-a'"
        :class="params.class"
        :target="params.target"
        :href="params.path"
    >
        {{params.title}}
        <slot v-if="params.isSlotIsset"/>
    </a>
    <!-- / -->

    <a v-else-if="type === 'a'" v-bind="$attrs">
        <slot v-if="$slots.default" />
        <template v-else>
            {{ label }}
        </template>
        <slot name="after" />
    </a>

    <div
        v-else-if="type === 'div'"
        class="transition duration-300 hover:opacity-75 flex"
        :class="{
          [params.class ?? '']: true,
          'disabled': disabled || !!loading,
        }"
    >
        <slot />

        <svg v-if="!!loading" aria-hidden="true" class="inline w-6 mr-2 text-[#ffffff6a] animate-spin dark:text-gray-600 fill-[#ffffffb5]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
        </svg>
        <div class="flex-1" :class="params?.isStartItemInBlock ? 'text-start' : 'text-center'" v-else-if="!!label || !!params.title">
            {{ label ?? params.title }}
        </div>

        <slot name="after" />
    </div>

    <button
        v-else
        class="default_button"
        :class="{
          [params.class]: true,
          '!cursor-not-allowed opacity-50': disabled || !!loading,
          'bg-default': shouldApplyBgDefault(label ?? params.title)
        }"
        :disabled="disabled || !!loading"
    >
        <slot />

        <svg v-if="!!loading" aria-hidden="true" class="inline w-6 h-6 text-[#ffffff6a] animate-spin dark:text-gray-600 fill-[#ffffffb5]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
        </svg>
        <template v-else>
            {{ label ?? params.title }}
        </template>
    </button>
</template>
<script>
const EXCLUDED_BUTTON_KEYWORDS = [
  // English
  'exit', '?', 'cancel', 'register',
  // Russian
  'выход', 'отмена', 'зарегистрироваться', 'подтвердить'
]; //todo поменять

/**
 * @description
 * @params {
 *  class: Класссы css,
 *  type: Типы тэгов (button, link, div, link-a(внешняя ссылка)),
 *  title: Текст (тайтл) тэгов,
 *  path: Путь для ссылки,
 *  isSlotIsset: Флаг наличия или отсутсвия slot
 *  actionType: тип функции при перечесления циклом
 *  }
 */
export default {
    name: 'BtnWrapper',
    props: {
        label: String,
        params: {
            type: Object,
            default: {}
        },
        loading: Boolean
    },
    computed: {
        type: vm => (vm.$attrs.type ?? vm.params.type ?? 'button'),
        disabled: vm => (vm.$attrs.disabled ?? vm.params.disabled)
    },
  methods: {
    shouldApplyBgDefault(labelText) {
      if (!labelText || typeof labelText !== 'string') return true
      return !EXCLUDED_BUTTON_KEYWORDS.some(kw =>
          labelText.toLowerCase().includes(kw))
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/common/variables/variables.scss';

.default_button {
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: $ButtonBlue;
    color: $ButtonWhite;
    border-radius: 8px;
    // padding: 18.5px 18px;
    padding: .7rem 1rem;
    text-wrap: nowrap;
}
.disabled {
    cursor:not-allowed !important;
}
</style>
